import React from 'react';
import CustomLink from '../CustomLink';
import { DiscountBannerText } from '../../Constants';
import { useTranslation } from 'react-i18next';
import { isGermanLanguage } from '../../utils/language';
const DiscountBanner = () => {
  const { t, i18n } = useTranslation();
  const quiz_id = localStorage.getItem('quiz_id');

  return (
    <div className="t-flex t-flex-col sm:t-flex-row t-bg-navy t-py-1.5 t-items-center t-justify-center t-gap-0.5 sm:t-gap-4">
      <CustomLink
        to={quiz_id ? '/product-suggestion' : '/quiz'}
        className="t-flex t-items-center t-gap-1.5 t-font-sans t-font-bold t-text-[11px] sm:t-text-[13px] hover:t-no-underline t-whitespace-nowrap"
      >
        <span className="t-text-butter">•</span>{' '}
        <span className={`t-text-butter ${isGermanLanguage(i18n.language) ? '' : 't-uppercase'} t-tracking-wide`}>{t(DiscountBannerText)}</span>
      </CustomLink>
    </div>
  );
};

export default DiscountBanner;
